module.exports = __webpack_public_path__ + "img/no_data.73639d67.png";